<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="teal">
        <v-icon dark>
          place
        </v-icon>
        <h4>El Arenal S/N-Quillabamba</h4>
        <v-spacer />
        <v-icon dark>
          info
        </v-icon>
        <h4>Dirección de Admisión UNIQ</h4>
        <v-spacer />
        <v-icon dark>
          email
        </v-icon>
        <h4>admision@uniq.edu.pe</h4>
        <v-spacer />
        <v-icon dark>
          phone
        </v-icon>
        <h4>084-282728</h4>
        <v-spacer />
        <v-icon dark>
          phone_iphone
        </v-icon>
        <h4>914608901 - 962984333 - 910820591</h4>
        <br>
        <br>
      </v-card-title>
      <v-card-actions class="grey darken-3 justify-center">
        <strong class="subheading">Dirección de Admisión.!</strong>
        &copy;2021 — <strong>Universidad Nacional Intercultural de Quillabamba</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  data: () => ({
    icons: ['email']
  })
}
</script>
